import { useState } from "react";
import { TextField, Button } from "@mui/material";
import { useAllProduct } from "../../../api-context/commonApiContext";
import { useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import approved from "./Animation-SuccessfulGIF.json";
import styles from "./getEscrowDetails.module.css";
import config from "../../../service/config";
import FullScreenLoader from "../../../reusable/loader/FullScreenLoader";

const GetEscrowDetails = () => {
  const { clientId, makerLimit, loading, setLoading, setRefreshData } =
    useAllProduct();
  const [escrowDetails, setEscrowDetails] = useState({
    reg_company_name: "",
    pan: "",
    gst: "",
    purpose_of_escrow: "",
    pri_con_fname: "",
    pri_con_lasName: "",
    pri_con_emailId: "",
    ph_number: "",
    vanPrefix: "",
    mailEscId: "",
    subEscId: "",
  });
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const [successNotification, setSuccessNotification] = useState(false);
  const handleChange = (field) => (e) => {
    setEscrowDetails({ ...escrowDetails, [field]: e.target.value });
    setErrors({ ...errors, [field]: "" }); // clear error on change
  };

  const handleSubmit = () => {
    const {
      reg_company_name,
      pan,
      gst,
      purpose_of_escrow,
      pri_con_fname,
      pri_con_lasName,
      pri_con_emailId,
      ph_number,
      mailEscId,
      subEscId,
    } = escrowDetails;

    const newErrors = {};

    const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const isValidPAN = (pan) => /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pan);
    const isValidPhone = (phone) => /^[6-9]\d{9}$/.test(phone);
    const isValidEscrowId = (id) => /^[0-9]{5,10}$/.test(id);
    const isValidGST = (gst) =>
      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(gst);

    if (!reg_company_name)
      newErrors.reg_company_name = "Company name is required.";
    if (!pan) {
      newErrors.pan = "PAN number is required.";
    } else if (!isValidPAN(pan)) {
      newErrors.pan = "Enter a valid 10-character PAN (e.g., ABCDE1234F).";
    }
    if (!gst) {
      newErrors.gst = "GST number is required.";
    } else if (!isValidGST(gst)) {
      newErrors.gst = "Enter a valid 15-character GST number.";
    }
    if (!purpose_of_escrow)
      newErrors.purpose_of_escrow = "Purpose of escrow is required.";
    if (!pri_con_fname) newErrors.pri_con_fname = "First name is required.";
    if (!pri_con_lasName) newErrors.pri_con_lasName = "Last name is required.";
    if (!pri_con_emailId) {
      newErrors.pri_con_emailId = "Email ID is required.";
    } else if (!isValidEmail(pri_con_emailId)) {
      newErrors.pri_con_emailId = "Enter a valid email address.";
    }
    if (!ph_number) {
      newErrors.ph_number = "Phone number is required.";
    } else if (!isValidPhone(ph_number)) {
      newErrors.ph_number = "Enter a valid 10-digit Indian mobile number.";
    }
    if (!mailEscId) {
      newErrors.mailEscId = "Main escrow ID is required.";
    } else if (!isValidEscrowId(mailEscId)) {
      newErrors.mailEscId = "Main escrow ID must be 5–10 digits.";
    }

    if (!subEscId) {
      newErrors.subEscId = "Sub escrow ID is required.";
    } else if (!isValidEscrowId(subEscId)) {
      newErrors.subEscId = "Sub escrow ID must be 5–10 digits.";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({}); // clear all errors
    setLoading(true);
    const payload = {
      registered_company_name: reg_company_name,
      pan,
      gst,
      purpose_of_escrow,
      primary_contact_first_name: pri_con_fname,
      primary_contact_last_name: pri_con_lasName,
      primary_contact_email_id: pri_con_emailId,
      phone_number: ph_number,
      van_prefix: "ESCROW",
      main_escrow_id: mailEscId,
      sub_escrow_id: subEscId,
      client_id: clientId,
    };

    fetch(`${config.node_api_endpoint}/api/add-escrow`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": process.env.REACT_APP_API_KEY,
      },
      body: JSON.stringify(payload),
    })
      .then((res) => {
        if (!res.ok)
          return res.json().then((err) => {
            throw new Error(err.message);
          });
        return res.json();
      })
      .then(() =>
        fetch(`${config.node_api_endpoint}/api/escrow-details`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_API_KEY,
          },
          body: JSON.stringify({
            client_id: clientId,
            registered_company_name: reg_company_name,
            main_escrow_id: mailEscId,
            sub_escrow_id: subEscId,
          }),
        })
      )
      .then((res) => {
        if (!res.ok)
          return res.json().then((err) => {
            throw new Error(err.message);
          });
        setRefreshData(true);
        return res.json();
      })
      .then(() => setSuccessNotification(true))
      .catch((err) => alert(err.message))
      .finally(() => setLoading(false));
  };

  return (
    <>
      <FullScreenLoader spinning={loading} />
      {successNotification ? (
        <div className={styles.modalBackdrop}>
          <div className={styles.modalContainer}>
            <div className={`d-flex justify-content-center`}>
              <Lottie
                className={styles.httpslottiefilescomanimatIcon}
                animationData={approved}
                loop
              />
            </div>
            <div className={styles.successMessage}>
              Master created successfully
            </div>
            <div className="d-flex justify-content-center gap-3 mt-3">
              <button
                className={`${styles.transactionsButtons} ${styles.activeButton}`}
                onClick={() => navigate("/escrow-management")}
              >
                <div className={styles.transactions}>
                  Return to Escrow management
                </div>
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className="p-4 bg-white border border-1 rounded mt-4">
          <button
            className="btn btn-link text-decoration-none ps-0 mb-3"
            style={{ color: "#4C4E64" }}
            onClick={() => navigate("/escrow-management")}
          >
            <span className="me-2">
              <img src="/backArrow.svg" />
            </span>{" "}
            Back
          </button>
          <h4 className="mb-4 fw-semibold">Add Escrow</h4>

          <div className="row">
            <div className="col">
              <TextField
                label="Registered company name"
                fullWidth
                variant="outlined"
                className="mb-3"
                value={escrowDetails.reg_company_name}
                onChange={handleChange("reg_company_name")}
                error={!!errors.reg_company_name}
                helperText={errors.reg_company_name}
                slotProps={{
                  inputLabel: {
                    sx: {
                      color: "#4C4E64 !important", // override red error color
                      "&.Mui-focused": {
                        color: "#4C4E64 !important",
                      },
                      "&.Mui-error": {
                        color: "#4C4E64 !important",
                      },
                    },
                  },
                }}
              />
            </div>
            <div className="col">
              <TextField
                label="PAN"
                fullWidth
                variant="outlined"
                className="mb-3"
                value={escrowDetails.pan}
                onChange={handleChange("pan")}
                error={!!errors.pan}
                helperText={errors.pan}
                slotProps={{
                  inputLabel: {
                    sx: {
                      color: "#4C4E64 !important", // override red error color
                      "&.Mui-focused": {
                        color: "#4C4E64 !important",
                      },
                      "&.Mui-error": {
                        color: "#4C4E64 !important",
                      },
                    },
                  },
                }}
              />
            </div>
          </div>

          <div className="row">
            <div className="col">
              <TextField
                label="GST"
                fullWidth
                variant="outlined"
                className="mb-3"
                value={escrowDetails.gst}
                onChange={handleChange("gst")}
                error={!!errors.gst}
                helperText={errors.gst}
                slotProps={{
                  inputLabel: {
                    sx: {
                      color: "#4C4E64 !important", // override red error color
                      "&.Mui-focused": {
                        color: "#4C4E64 !important",
                      },
                      "&.Mui-error": {
                        color: "#4C4E64 !important",
                      },
                    },
                  },
                }}
              />
            </div>
            <div className="col">
              <TextField
                label="Purpose of escrow"
                fullWidth
                variant="outlined"
                className="mb-3"
                value={escrowDetails.purpose_of_escrow}
                onChange={handleChange("purpose_of_escrow")}
                error={!!errors.purpose_of_escrow}
                helperText={errors.purpose_of_escrow}
                slotProps={{
                  inputLabel: {
                    sx: {
                      color: "#4C4E64 !important", // override red error color
                      "&.Mui-focused": {
                        color: "#4C4E64 !important",
                      },
                      "&.Mui-error": {
                        color: "#4C4E64 !important",
                      },
                    },
                  },
                }}
              />
            </div>
          </div>

          <h4 className="mb-4 fw-semibold">Personal Contact</h4>
          <div className="row">
            <div className="col">
              <TextField
                label="Primary contact first name"
                fullWidth
                variant="outlined"
                className="mb-3"
                value={escrowDetails.pri_con_fname}
                onChange={handleChange("pri_con_fname")}
                error={!!errors.pri_con_fname}
                helperText={errors.pri_con_fname}
                slotProps={{
                  inputLabel: {
                    sx: {
                      color: "#4C4E64 !important", // override red error color
                      "&.Mui-focused": {
                        color: "#4C4E64 !important",
                      },
                      "&.Mui-error": {
                        color: "#4C4E64 !important",
                      },
                    },
                  },
                }}
              />
            </div>
            <div className="col">
              <TextField
                label="Primary contact last name"
                fullWidth
                variant="outlined"
                className="mb-3"
                value={escrowDetails.pri_con_lasName}
                onChange={handleChange("pri_con_lasName")}
                error={!!errors.pri_con_lasName}
                helperText={errors.pri_con_lasName}
                slotProps={{
                  inputLabel: {
                    sx: {
                      color: "#4C4E64 !important", // override red error color
                      "&.Mui-focused": {
                        color: "#4C4E64 !important",
                      },
                      "&.Mui-error": {
                        color: "#4C4E64 !important",
                      },
                    },
                  },
                }}
              />
            </div>
          </div>

          <div className="row">
            <div className="col">
              <TextField
                label="Primary contact email ID"
                fullWidth
                variant="outlined"
                className="mb-3"
                value={escrowDetails.pri_con_emailId}
                onChange={handleChange("pri_con_emailId")}
                error={!!errors.pri_con_emailId}
                helperText={errors.pri_con_emailId}
                slotProps={{
                  inputLabel: {
                    sx: {
                      color: "#4C4E64 !important", // override red error color
                      "&.Mui-focused": {
                        color: "#4C4E64 !important",
                      },
                      "&.Mui-error": {
                        color: "#4C4E64 !important",
                      },
                    },
                  },
                }}
              />
            </div>
            <div className="col">
              <TextField
                label="Phone number"
                fullWidth
                variant="outlined"
                className="mb-3"
                value={escrowDetails.ph_number}
                onChange={handleChange("ph_number")}
                error={!!errors.ph_number}
                helperText={errors.ph_number}
                slotProps={{
                  inputLabel: {
                    sx: {
                      color: "#4C4E64 !important", // override red error color
                      "&.Mui-focused": {
                        color: "#4C4E64 !important",
                      },
                      "&.Mui-error": {
                        color: "#4C4E64 !important",
                      },
                    },
                  },
                }}
              />
            </div>
          </div>

          <h4 className="mb-4 fw-semibold">Virtual Account Details</h4>
          <TextField
            label="Virtual account number prefix"
            fullWidth
            variant="outlined"
            className="mb-3"
            value="ESCROW"
            slotProps={{
              inputLabel: {
                sx: {
                  color: "#4C4E64 !important", // override red error color
                  "&.Mui-focused": {
                    color: "#4C4E64 !important",
                  },
                  "&.Mui-error": {
                    color: "#4C4E64 !important",
                  },
                },
              },
            }}
            disabled
          />

          <div className="row">
            <div className="col">
              <TextField
                label="Main escrow ID"
                fullWidth
                variant="outlined"
                className="mb-3"
                value={escrowDetails.mailEscId}
                onChange={handleChange("mailEscId")}
                error={!!errors.mailEscId}
                helperText={errors.mailEscId}
                slotProps={{
                  inputLabel: {
                    sx: {
                      color: "#4C4E64 !important", // override red error color
                      "&.Mui-focused": {
                        color: "#4C4E64 !important",
                      },
                      "&.Mui-error": {
                        color: "#4C4E64 !important",
                      },
                    },
                  },
                }}
              />
            </div>
            <div className="col">
              <TextField
                label="Sub escrow ID"
                fullWidth
                variant="outlined"
                className="mb-3"
                value={escrowDetails.subEscId}
                onChange={handleChange("subEscId")}
                error={!!errors.subEscId}
                helperText={errors.subEscId}
                slotProps={{
                  inputLabel: {
                    sx: {
                      color: "#4C4E64 !important", // override red error color
                      "&.Mui-focused": {
                        color: "#4C4E64 !important",
                      },
                      "&.Mui-error": {
                        color: "#4C4E64 !important",
                      },
                    },
                  },
                }}
              />
            </div>
          </div>

          <div className="w-25">
            <Button
              variant="contained"
              fullWidth
              onClick={handleSubmit}
              style={{ backgroundColor: "#2348ab" }}
            >
              Create Master Escrow
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

export default GetEscrowDetails;
